import * as api from '@/api/authorizedLoginIp'

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    AUTHORIZED_LOGIN_IP_LIST ({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.AUTHORIZED_LOGIN_IP_LIST(params.pageNum, params.pageSize).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AUTHORIZED_LOGIN_IP_SUBMIT ({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.AUTHORIZED_LOGIN_IP_SUBMIT(params.ips).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AUTHORIZED_LOGIN_IP_DELETE ({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.AUTHORIZED_LOGIN_IP_DELETE(params.id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    AUTHORIZED_LOGIN_IP_LOCAL ({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.AUTHORIZED_LOGIN_IP_LOCAL(params.ips).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/authorizedLoginIp.js